export const APP_CONFIG = {
  name: 'Cates Roofing & Contracting',
  tagline: 'Excellence in Every Shingle',
  description: 'Professional roofing services — cleaning, repair, replacement & commercial. Serving the greater metropolitan area with pride since 2003.',
  phone: '(555) 847-ROOF',
  phoneRaw: '5558472663',
  email: 'info@catesroofing.com',
  emailSupport: 'support@catesroofing.com',
  address: '1247 Ridge Top Drive, Suite 100',
  city: 'Nashville',
  state: 'TN',
  zip: '37201',
  website: 'https://catesroofing.com',
  socialLinks: {
    facebook: 'https://facebook.com/catesroofing',
    instagram: 'https://instagram.com/catesroofing',
    twitter: 'https://twitter.com/catesroofing',
    linkedin: 'https://linkedin.com/company/catesroofing',
    youtube: 'https://youtube.com/@catesroofing',
  },
  businessHours: {
    weekdays: '7:00 AM – 7:00 PM',
    saturday: '8:00 AM – 5:00 PM',
    sunday: 'Emergency Only',
  },
  licenses: ['TN Lic. #1234567', 'GAF Master Elite Certified', 'CertainTeed SELECT ShingleMaster'],
  warranty: {
    workmanship: '10 Years',
    materials: 'Up to 50 Years (manufacturer)',
  },
  financing: {
    available: true,
    minAmount: 500,
    maxMonths: 60,
    rate: '0% for 18 months',
  },
  emergencyAvailable: true,
  founded: 2003,
};

export const ROUTES = {
  // Public
  HOME: '/',
  SERVICES: '/services',
  SERVICE_DETAIL: '/services/:slug',
  GALLERY: '/gallery',
  TESTIMONIALS: '/testimonials',
  ABOUT: '/about',
  CONTACT: '/contact',
  QUOTE: '/get-quote',
  BLOG: '/blog',
  BLOG_POST: '/blog/:slug',
  FAQ: '/faq',
  FINANCING: '/financing',
  SERVICE_AREAS: '/service-areas',
  EMERGENCY: '/emergency',
  CAREERS: '/careers',
  PRIVACY: '/privacy',
  TERMS: '/terms',

  // Auth
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',

  // Customer Portal
  CUSTOMER: '/portal',
  CUSTOMER_DASHBOARD: '/portal/dashboard',
  CUSTOMER_REQUESTS: '/portal/requests',
  CUSTOMER_QUOTES: '/portal/quotes',
  CUSTOMER_APPOINTMENTS: '/portal/appointments',
  CUSTOMER_PROJECTS: '/portal/projects',
  CUSTOMER_INVOICES: '/portal/invoices',
  CUSTOMER_DOCUMENTS: '/portal/documents',
  CUSTOMER_PROFILE: '/portal/profile',
  CUSTOMER_NOTIFICATIONS: '/portal/notifications',

  // Admin Portal
  ADMIN: '/admin',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_LEADS: '/admin/leads',
  ADMIN_CUSTOMERS: '/admin/customers',
  ADMIN_APPOINTMENTS: '/admin/appointments',
  ADMIN_PROJECTS: '/admin/projects',
  ADMIN_QUOTES: '/admin/quotes',
  ADMIN_INVOICES: '/admin/invoices',
  ADMIN_CONTRACTORS: '/admin/contractors',
  ADMIN_TEAM: '/admin/team',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_SETTINGS: '/admin/settings',
  ADMIN_AUDIT: '/admin/audit',
  ADMIN_ROLES: '/admin/roles',
  ADMIN_BLOG: '/admin/blog',
  ADMIN_CMS: '/admin/cms',

  // Contractor Portal
  CONTRACTOR: '/contractor',
  CONTRACTOR_DASHBOARD: '/contractor/dashboard',
  CONTRACTOR_JOBS: '/contractor/jobs',
  CONTRACTOR_SCHEDULE: '/contractor/schedule',
  CONTRACTOR_EARNINGS: '/contractor/earnings',
  CONTRACTOR_PROFILE: '/contractor/profile',
  CONTRACTOR_DOCUMENTS: '/contractor/documents',
};

export const FEATURE_FLAGS = {
  CHATBOT: false,
  SMS_INTEGRATION: false,
  PAYMENT_PORTAL: true,
  MULTI_TENANT: false,
  AI_ESTIMATES: false,
  DRONE_INSPECTION: false,
};

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
};
